import { render, staticRenderFns } from "./nomor-faktur-simple.vue?vue&type=template&id=1a87c620&"
import script from "./nomor-faktur-simple.vue?vue&type=script&setup=true&lang=js&"
export * from "./nomor-faktur-simple.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports